import { useState } from "react";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import Input from "../reusable_components/Input";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle, title } from "../utils/style";


function AddTraining(props) {
    const [formData, setFormData] = useState({});
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['name', 'duration'];

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    function addFile(e) {
        let data = { ...formData };

        if (e.target.name === 'ebook') {
            data.ebook = e.target.files[0]
        } else if (e.target.name === 'video') {
            data.video = e.target.files[0]
        }

        setFormData(data);
    }

    async function addTraining() {
        if (
            formData.name && formData.name.length > 0 &&
            (
                (formData.link && (formData.link.match('http://') || formData.link.match('https://')) && formData.link.match('.com')) ||
                formData.ebook ||
                formData.video
            ) &&
            !inputErrors.includes('error')
        ) {
            var data;
            if (formData.ebook || formData.video) {
                data = new FormData();
                Object.keys(formData).forEach(cd => data.append(cd, formData[cd]))
            } else {
                data = formData
            }
            postData(`${url}/course`, data, console.log, () => { props.setShowModal(false); props.reload(1 + Math.random()) })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-md p-4 w-2/3">
                <div>
                    <div className={modalTitle}>Add Training</div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                        <div className={label}>Course Name</div>
                        <div className="col-span-2">
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='name'
                                type='text'
                                value={formData.name}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className={label}>Course Duration</div>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='duration'
                                type='number'
                                value={formData.duration}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">
                        <div className={label}>Course URL</div>
                        <div className="col-span-2">

                            <Input
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='link'
                                value={formData.url}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className={label}>Video URL</div>
                        <div className="col-span-2">
                            <Input
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                className={inputStyle}
                                name='video'
                                value={formData.video}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <Input
                        index={4}
                        inputErrors={inputErrors}
                        setInputErrors={setInputErrors}
                        missingFields={missingFields}
                        required={true}
                        id='ebook'
                        type="file"
                        accept="application/pdf"
                        className="hidden"
                        name='ebook'
                        onChange={e => addFile(e)}
                    />
                    {/* <Input 
                        id="video" 
                        type="file" 
                        accept="video/mp4,video/x-m4v,video/*" 
                        className="hidden" 
                        name='video' 
                        onChange={e => addFile(e)}
                    /> */}
                    <div className="grid grid-cols-6 gap-4 py-1 px-2 mt-4">

                        <div className={label}>E-Book</div>
                        
                        <div className="text-center col-span-2">
                            <label htmlFor="ebook" className="py-2 px-4 border text-blue-500 border-blue-300 rounded-lg text-sm">Upload PDF</label>
                        </div>

                    </div>
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={e => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => addTraining()} className={btnOne} name={'Submit'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {
                        showInputError && 'Please fill all the fields as directed!'
                    }
                </div>
            </div>
        </div>
    )
}

export default AddTraining;